<template>
  <section>
    <errors v-if="isVisibleErrorsModal"></errors>
    <question v-if="display"></question>
    <success v-if="isSuccessModalVisible" :closeAction="creationSucceeded ? goToFundingSources : null"></success>
    <address-suggestion v-if="isSuggestedAddressModalVisible"></address-suggestion>

    <div class="content-wrapper">
      <div class="content-heading">
        Personal information
        <small data-localize="dashboard.WELCOME"></small>
      </div>

      <div class="row">
        <spinner v-if="disableSubmit"></spinner>
        <div class="col-lg-12">

          <onboarding-wizard :userStatus="userStatus"></onboarding-wizard>

          <div id="panelChart9" class="panel panel-default">

            <div class="panel-heading top-margin">
              <div class="panel-title">
                Personal Information
              </div>
            </div>

            <form role="form" class="mb-lg" v-on:submit.prevent="validateAndSubmitUserProfile" novalidate>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="address">First name*</label>
                    <input type="text" name="FirstName" id="FirstName" v-model="user.firstName" placeholder="First name" :class="{ 'form-control': true, 'form-control-error': errors.has('FirstName') }" v-validate="{required: true}" />
                    <span v-if="errors.has('FirstName')" class="error-feedback">Required</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="address">Last name*</label>
                    <input type="text" name="LastName" id="LastName" v-model="user.lastName" placeholder="Last name" :class="{ 'form-control': true, 'form-control-error': errors.has('LastName') }" v-validate="{required: true}" />
                    <span v-if="errors.has('LastName')" class="error-feedback">Required</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <label for="date-time-input">Date of birth*</label>
                  <div class="form-group input-group date birth-field-bottom">
                    <date-picker placeholder="mm/dd/yyyy" v-model="user.dateOfBirth" id="date-time-input" name="date-time-input" :wrap="true" :config="dateBirthConfig" :class="{ 'form-control': true, 'form-control-error': isBirthFieldInvalid }" v-validate="{required: true}"
                      @blur.native="checkDateBirth(user.dateOfBirth)">
                    </date-picker>
                    <div class="input-group-addon">
                      <span class="fa fa-calendar"></span>
                    </div>
                  </div>
                  <span v-if="isBirthFieldInvalid" class="error-feedback">Required</span>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="ssn">Social security number*</label>
                    <input type="text" name="ssn" id="ssn" v-model="user.socialSecurityNum" placeholder="000-00-0000" v-on:click="user.socialSecurityNum=''"
                    :class="{ 'form-control': true, 'form-control-error': errors.has('ssn') }" v-validate="{required: true}" v-mask="'***-**-9999'" autocomplete="off"
                    @input="ssnInput"/>
                  <span v-if="errors.has('ssn')" class="error-feedback">{{ errors.first('ssn') }}</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="primaryPhoneNum">Primary phone number*</label>
                    <input type="text" id="primaryPhoneNum" name="primaryPhoneNum" v-model="user.primaryPhoneNum" placeholder="Phone number" :class="{ 'form-control': true, 'form-control-error': errors.has('primaryPhoneNum') }" v-validate="{required: true}" v-mask="'(999) 999-9999'"
                    />
                    <span v-if="errors.has('primaryPhoneNum')" class="error-feedback">Required</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="ssn">Secondary phone number</label>
                    <input v-model="user.secondaryPhoneNum" class="form-control" type="text" id="spn" v-mask="'(999) 999-9999'" />
                  </div>
                </div>
              </div>

              <addresses-form
                v-if="user.residentialAddress && user.mailingAddress"
                v-bind:firstTitle="'Residential Address'"
                v-bind:residentialAddress="user.residentialAddress"
                v-bind:secondTitle="'Mailing Address'"
                v-bind:mailingAddress="user.mailingAddress"
                v-bind:key="1"
                ref="addresses" >
              </addresses-form>

              <div class="row">
                <div class="col-md-12 form-group">
                  <div class="checkbox c-checkbox check-margin">
                    <label>
                      <input type="checkbox" value="" name="agreeTerms" v-model="agreeTerms">
                      <span class="fa fa-check"></span>
                      <terms-of-conditions />
                    </label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <button type="submit" v-bind:disabled="disableSubmitButton()" class="btn btn-info btn-lg button-submit">Submit</button>
                </div>
              </div>

              <div class="row" v-if="hasValidationErrors">
                <div class="col-md-12">
                  <div class="validation-error-message">
                    Please see errors above
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapMutations,
    mapActions,
    mapState,
    mapGetters,
  } from 'vuex';
  import {
    SET_ACCOUNT_STATUS,
    SET_ERRORS_MODAL_INFO,
    SET_SUGGESTED_ADDRESS,
    SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
    SET_SUGGESTED_ADDRESS_TYPE,
    SET_SUGGESTED_ADDRESS_YES_METHOD,
    SET_USER,
    SHOW_ERRORS_MODAL,
    SHOW_SUCCESS_MODAL,
    SHOW_QUESTION_MODAL,
    HIDE_QUESTION_MODAL,
    SET_ACTIVE_ACCOUNT_ID,
  } from '@/store/mutation-types';
  import moment from 'moment';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import addressSuggestion from '@/components/modals/AddressSuggestion';
  import errors from '@/components/modals/Errors';
  import success from '@/components/modals/Success';
  import OnboardingWizard from '@/components/OnboardingWizard';
  import TermsOfConditions from '@/components/TermsOfConditions';
  import spinner from '@/components/widgets/Spinner';
  import UserProfile from '@/entities/userProfile';
  import Question from '@/components/modals/Question';
  import RestrictedTwoInputs from '@/components/formControls/RestrictedTwoInputs';
  import { addressAreEqual, zipRegex } from '@/util';
  import addresses from '@/components/Addresses';
  import {
    Constants,
  } from '../data/static/constants';
  import {
    UserTypes,
  } from '../data/static/userTypes';


  export default {
    name: 'accountCreation',
    created() {
      this.setUser(new UserProfile());
    },
    async beforeMount() {
      await this.loadUserProfile();

      if (!this.hasBeenCreatedAccount) {
        return;
      }

      await this.checkUserStatus();
    },
    async mounted() {
      await this.loadUserProfile();
    },
    data() {
      return {
        minimumAge: 18,
        isResidentDefaultAddress: false,
        disableSubmit: false,
        agreeTerms: false,
        dateBirthConfig: {
          format: 'MM/DD/YYYY',
        },
        isBirthFieldInvalid: false,
        dateBirthFormat: 'YYYY-MM-DD',
        creationSucceeded: false,
      };
    },
    computed: {
      ...mapState('home', [
        'userStatus',
      ]),
      ...mapState('user', [
        'newUserEmail',
      ]),
      ...mapState('app', [
        'activeAccount',
        'user',
        'geoLocation',
      ]),
      ...mapGetters('app', [
        'hasBeenCreatedAccount',
      ]),
      ...mapState('authentication', [
        'states',
        'countries',
      ]),
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('accountCreation', [
        'isSuggestedAddressModalVisible',
        'suggestedAddressModalYesCall',
      ]),
      ...mapState('success', [
        'isSuccessModalVisible',
      ]),
      ...mapState('question', [
        'display',
      ]),
      hasValidationErrors() {
        return this.errors.has('FirstName') ||
          this.errors.has('LastName') ||
          this.errors.has('ssn') ||
          this.errors.has('primaryPhoneNum');
      },
    },
    watch: {
      async suggestedAddressModalYesCall({ payload, suggestedAddress, addressType }) {
        const address = this.truncateAddressIfNecessary(suggestedAddress);
        if (!this.$refs.addresses.isMailingAddressDifferent) {
          this.user.residentialAddress = address;
          this.user.mailingAddress = address;
          this.$refs.addresses.setResidencialAddress(address);
          this.$refs.addresses.setMailingAddress(address);
        }
        if (['residential', 'organization'].includes(addressType)) {
          this.user.residentialAddress = address;
          this.$refs.addresses.setResidencialAddress(address);
        } else if (addressType === 'mailing') {
          this.user.mailingAddress = address;
          this.$refs.addresses.setMailingAddress(address);
        }
        await this.save({
          ...payload,
          residentialAddress: this.user.residentialAddress,
          mailingAddress: this.user.mailingAddress,
        });
      },
    },
    methods: {
      ...mapActions('app', [
        'activeAccountId',
      ]),
      ...mapActions('home', [
        'getUserStatus',
      ]),
      ...mapActions('accountCreation', [
        'saveUserProfile',
        'updateAccountProvisioned',
        'updateDwollaUser',
        'getUserProfile',
      ]),
      ...mapMutations('app', {
        setActiveAccountId: SET_ACTIVE_ACCOUNT_ID,
      }),
      ...mapMutations('app', {
        setUser: SET_USER,
        setAccountUser: SET_ACCOUNT_STATUS,
      }),
      ...mapMutations('success', {
        showSuccessModal: SHOW_SUCCESS_MODAL,
      }),
      ...mapMutations('accountCreation', {
        setSuggestedAddress: SET_SUGGESTED_ADDRESS,
        setSuggestedAddressType: SET_SUGGESTED_ADDRESS_TYPE,
        setSuggestedAddressModalVisible: SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
        setSuggestedAddressYesMethod: SET_SUGGESTED_ADDRESS_YES_METHOD,
      }),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      residentialAdressUpdated($event) {
        this.user.residentialAddress.streetAddress1 = $event.primary;
        this.user.residentialAddress.streetAddress2 = $event.secondary;
      },
      mailingAddressUpdated($event) {
        this.user.mailingAddress.streetAddress1 = $event.primary;
        this.user.mailingAddress.streetAddress2 = $event.secondary;
      },
      async loadUserProfile() {
        const userData = await this.getUserProfile();
        await this.handleUserProfile(userData);
      },
      async handleUserProfile(data) {
        if (this.isNewUser(data)) {
          await this.handleUserMetadata(data);
          return;
        }
        const user = Object.assign({}, data);
        user.socialSecurityNum = `xxx-xx-${data.socialSecurityNum}`;
        user.dateOfBirth = moment.utc(`${data.dateOfBirth} 12:00:00`);
        user.updateCount = user.updateCount ? user.updateCount : 0;
        user.isResidentDefaultAddress = !addressAreEqual(user.residentialAddress,
          user.mailingAddress);
        this.setUser(user);
      },
      handleUserMetadata({
        state,
      }) {
        const USCountry = this.geoLocation.countries.find(ct => ct.abbreviation.includes('US'));
        this.user.residentialAddress.state = state;
        this.user.residentialAddress.country = USCountry.abbreviation;
        this.user.mailingAddress.country = USCountry.abbreviation;
        this.user.dateOfBirth = '';
      },
      isNewUser(data) {
        return data.email === '' || (!data.firstName && !data.lastName);
      },
      isDateBirthValid(dateOfBirth) {
        if (dateOfBirth === '') {
          return false;
        }
        const birthYear = new Date(dateOfBirth).getFullYear();
        const currentYear = new Date().getFullYear();
        return (currentYear - birthYear) >= this.minimumAge;
      },
      getSsnDigits(ssn) {
        return ssn.replace(/[- ]/g, '');
      },
      getPhoneDigits(phoneNum) {
        return phoneNum.replace(/[-() ]/g, '');
      },
      getDateOnlyDOB(date) {
        return moment(date).format(this.dateBirthFormat).toString();
      },
      copyMailingAddress() {
        this.user.mailingAddress = Object.assign({}, this.user.residentialAddress);
      },
      isStateSelected(userProfile) {
        return userProfile.residentialAddress.state.length > 0;
      },
      checkDateBirth(dateOfBirth) {
        if (dateOfBirth === '' || dateOfBirth === null) {
          this.isBirthFieldInvalid = true;
        } else {
          this.isBirthFieldInvalid = false;
        }
      },
      validateUserProfile(userProfile, agreeTerms) {
        const listUserErrors = [];
        if (!this.isDateBirthValid(userProfile.dateOfBirth)) {
          listUserErrors.push('You must be 18 years or older in order to invest with us.');
        }
        const SsnRegex = /^[0-9x]{3}\-?[0-9x]{2}\-?[0-9]{4}$/; // eslint-disable-line no-useless-escape
        if (!SsnRegex.test(userProfile.socialSecurityNum)) {
          listUserErrors.push('Enter a valid social security number.');
        }
        const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/; // eslint-disable-line no-useless-escape
        if (!phoneRegex.test(userProfile.primaryPhoneNum)) {
          listUserErrors.push('Enter a valid primary phone number.');
        }
        if (userProfile.secondaryPhoneNum && userProfile.secondaryPhoneNum.length > 0 &&
          !phoneRegex.test(userProfile.secondaryPhoneNum)) {
          listUserErrors.push('Enter a valid secondary phone number.');
        }
        if (!zipRegex.test(userProfile.residentialAddress.zipCode)) {
          listUserErrors.push('Provide a valid residential zip code.');
        }
        if (this.isResidentDefaultAddress &&
          !zipRegex.test(userProfile.mailingAddress.zipCode)) {
          listUserErrors.push('Provide a valid mailing zip code.');
        }
        if (!agreeTerms) {
          listUserErrors.push('Check the agree terms for submitting purposes.');
        }
        if (!this.isStateSelected(userProfile)) {
          listUserErrors.push('Please select a state in order to save your profile.');
        }
        return listUserErrors;
      },
      setDataWithoutMasks() {
        this.user.primaryPhoneNum = this.getPhoneDigits(this.user.primaryPhoneNum);
        this.user.socialSecurityNum = this.getSsnDigits(this.user.socialSecurityNum);
        this.user.dateOfBirth = this.getDateOnlyDOB(this.user.dateOfBirth);
        if (this.user.secondaryPhoneNum) {
          this.user.secondaryPhoneNum = this.getPhoneDigits(this.user.secondaryPhoneNum);
        }
      },
      truncateAddressIfNecessary(address) {
        const localAddress = { ...address };
        const hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
        const hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
        if (hasStreetAddress1 && hasStreetAddress2) {
          const totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
          if (totalAdressLength > 50) {
            const charsToCut = totalAdressLength - 50;
            localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
            return localAddress;
          }
        }
        return address;
      },
      showRetryModal() {
        this.showQuestionModal({
          title: Constants.fundingSource.modalTitle,
          question: Constants.fundingSource.retrySelfRegisterDisclaimer,
          yesButtonText: Constants.fundingSource.modalEditProfileButtonText,
          method: async () => {
            this.hideQuestionModal();
          } });
      },
      async save(payload) {
        try {
          if (this.hasBeenCreatedAccount && (this.userStatus && this.userStatus.status === 'retry')) {
            await this.updateAccountProvisioned({ user: payload });
          } else {
            await this.saveUserProfile({ user: payload });
          }
        } catch (err) {
          this.disableSubmit = false;

          // Check if this is an SSN-specific error
          const errorMessage = err && err.message ? err.message : 'An error occurred while saving your profile. Please try again.';

          if (errorMessage.toLowerCase().includes('social security number')) {
            // Add SSN validation error to show below the input field
            this.$validator.errors.add({
              field: 'ssn',
              msg: 'The social security number that was entered is not accepted. Please contact us at info@calvertimpact.org to confirm',
              id: 'ssn_error',
            });
            return;
          }

          // Show error modal for any other API errors
          this.setErrorsModalInfo([errorMessage]);
          this.showErrorsModal();
          return;
        }

        if (this.isSuggestedAddressModalVisible) {
          this.disableSubmit = false;

          return;
        }

        await this.loadUserProfile();

        const [account] = this.user.accounts;
        const {
          status,
        } = account;
        this.setAccountUser(status);

        this.updateActiveAccount(account);

        this.getUserStatus({
          accountId: this.activeAccount.id,
        })
        .then(({
          status: status2,
        }) => { // eslint-disable-line no-shadow
          this.disableSubmit = false;
          if (status2 === 'suspended') {
            this.$router.push({
              name: 'AccountSuspended',
            });
          } else if (status2 === 'retry') {
            this.showRetryModal();
          } else {
            this.creationSucceeded = true;
            this.showSuccessModal(Constants.home.successMessage);
            window.dataLayer.push({
              event: 'openInvestmentAccount',
              userID: `new_user:${this.newUserEmail}`,
            });
          }
        });
      },
      async validateAndSubmitUserProfile() {
        this.disableSubmit = true;

        // Clear any previous SSN errors
        this.$validator.errors.remove('ssn');

        const listUserErrors = this.validateUserProfile(this.user, this.agreeTerms);
        if (listUserErrors.length > 0) {
          this.showUserModalsError(listUserErrors);
          this.disableSubmit = false;
          return false;
        }
        if (!this.$refs.addresses.isMailingAddressDifferent) {
          this.copyMailingAddress();
        }
        this.setDataWithoutMasks();
        const requestUser = {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          userType: UserTypes.INVESTOR.name,
          primaryPhoneNum: this.user.primaryPhoneNum,
          secondaryPhoneNum: this.user.secondaryPhoneNum === '' ? null : this.user.secondaryPhoneNum,
          socialSecurityNum: this.user.socialSecurityNum,
          dateOfBirth: this.user.dateOfBirth,
          residentialAddress: this.user.residentialAddress,
          mailingAddress: this.user.mailingAddress,
        };

        return this.save(requestUser);
      },
      updateActiveAccount(account) {
        this.setActiveAccountId(account);
      },
      showUserModalsError(listUserErrors) {
        this.setErrorsModalInfo(listUserErrors);
        this.showErrorsModal();
      },
      disableSubmitButton() {
        return !this.user.firstName ||
          !this.user.lastName || !this.user.primaryPhoneNum ||
          !this.user.socialSecurityNum || !this.user.dateOfBirth ||
          this.disableSubmit || !this.agreeTerms ||
          (!this.user.residentialAddress.streetAddress1 ||
            !this.user.residentialAddress.zipCode ||
            !this.user.residentialAddress.city ||
            !this.user.residentialAddress.state ||
            (this.isResidentDefaultAddress &&
              (!this.user.mailingAddress.streetAddress1 ||
                !this.user.mailingAddress.zipCode ||
                !this.user.mailingAddress.city ||
                !this.user.mailingAddress.state
              )
            )
          ) ||
          // Check for validation errors
          this.errors.has('ssn') ||
          this.errors.has('FirstName') ||
          this.errors.has('LastName') ||
          this.errors.has('primaryPhoneNum');
      },
      checkUserStatus() {
        this.disableSubmit = true;
        const accountId = this.activeAccount.id;

        if (!this.hasBeenCreatedAccount) {
          this.disableSubmit = false;
          return;
        }

        // Without a real account there is no status to fetch. Asking for
        // account 0 returns a 403, which the HttpService interceptor turns
        // into a redirect to Home. Re-enable the form as the branch above does,
        // so the user is never left with a permanently disabled submit button.
        if (!accountId) {
          this.disableSubmit = false;
          return;
        }

        this.getUserStatus({
          accountId,
        }).then(({
          status,
          needs,
        }) => {
          if (status === 'retry') {
            this.disableSubmit = false;
            this.showRetryModal();
          } else if (status === 'suspended') {
            this.$router.push({
              name: 'AccountSuspended',
            });
          } else if (needs.includes('FUNDING_SOURCE')) {
            this.$router.push({
              name: 'AddFundingSource',
            });
          } else if (needs.includes('NOTE')) {
            this.$router.push({
              name: 'PurchaseNote',
              query: {
                first: 1,
              },
            });
          } else if (!needs.length) {
            this.$router.push({
              name: 'Notes',
            });
          } else {
            this.disableSubmit = false;
          }
        }).catch(() => {
          this.disableSubmit = false;
        });
      },
      goToFundingSources() {
        this.$router.push({
          name: 'AddFundingSource',
        });
      },
      ssnInput() {
        this.$validator.errors.remove('ssn');
      },
    },
    components: {
      datePicker,
      errors,
      spinner,
      success,
      RestrictedTwoInputs,
      TermsOfConditions,
      question: Question,
      'address-suggestion': addressSuggestion,
      'onboarding-wizard': OnboardingWizard,
      'addresses-form': addresses,
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .left-margin {
    margin-left: 2%;
  }
  .left-margin-title {
    margin-left: 18px;
  }
  .top-margin {
    margin-top: 2%;
  }
  .checkbox {
    margin-left: 10px;
  }
  .c-checkbox span,
  .c-radio span {
    margin-left: -28px;
  }
  .message-feedback {
    background-color: #dbe9db;
    margin-left: 2%;
    margin-top: 2%;
    margin-bottom: 2%;
    width: 66%;
  }
  .panel-heading {
    background-color: white !important;
    font-weight: 700;
    margin-left: -0.5%;
    color: #726f6f;
  }
  .button-submit {
    background-color: #127285;
  }
  .date-pick-style {
    width: 90%;
  }
  .content-wrapper {
    border-top: none;
  }
  .warning-heading {
    background-color: #f9f2ce !important;
    padding: 10px;
    margin: 0 auto 20px;
    font-size: 14px;
    font-weight: 500;
  }
  .birth-field-bottom {
    margin-bottom: 5px;
  }
  .validation-error-message {
    color: #d9534f;
    font-size: 14px;
    margin-top: 10px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// AccountCreation.vue?e4b936f0